// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__NvD49","small":"styles_small__Krrm9","medium":"styles_medium__YEzPc","large":"styles_large__JRQ-A"};